import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class EnvConfigService {
  private envConfig: any;
  private readonly renderer: Renderer2;
  private readonly fallbackFavicon: string = 'assets/images/favicon.png';
  private isInstallationSubject = new BehaviorSubject<boolean>(false); // Default: Not Installed
  isInstallation$ = this.isInstallationSubject.asObservable();

  constructor(private readonly http: HttpClient,
    private router: Router,
    private readonly rendererFactory : RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  loadConfig(): Observable<any> {
    return this.http.get<{ type: string; message: string; data: { data: any } }>(
      `${environment.API_ENDPOINT}common/configuration`
    ).pipe(
      tap((res) => {
        this.envConfig = res.data.data;
        let isInstallation = this.envConfig.installation == 0 ? false : true
        this.updateInstallationStatus(isInstallation)
      }),
      catchError((error) => {
        console.error('Failed to load configuration:', error);
        this.envConfig = {};
        return of(null);
      })
    );
  }
  updateInstallationStatus(status: boolean) {
    console.log(status,"===============")
    this.isInstallationSubject.next(status); // Update BehaviorSubject
    // if (status) {
    //   console.log('Installation completed, redirecting...');
    //   this.router.navigate(["/admin/dashboard"]);
    // }
  }
  getInstallationStatus(): boolean {
    return this.isInstallationSubject.getValue();
  }
  getEnvData() {
    return this.envConfig;
  }

  getImageBaseUrl(){
    return this.envConfig?.app?.baseurl
  }

  setFavicon(url: string): void {
    this.validateFavicon(url).then((isValid) => {
      const faviconUrl = isValid ? url : this.fallbackFavicon;
      console.log(faviconUrl, "favicon url");
      const link: HTMLLinkElement = this.getOrCreateFaviconElement();
      this.renderer.setAttribute(link, 'href', faviconUrl);
    });
  }

  private validateFavicon(url: string): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve(true);
      };
      img.onerror = () => {
        resolve(false);
      };
      img.src = url;
    });
  }



  private getOrCreateFaviconElement(): HTMLLinkElement {
    let link: HTMLLinkElement | null = document.querySelector('#favicon');
    if (!link) {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'id', 'favicon');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.appendChild(document.head, link);
    }
    return link;
  }
}
